module.exports = __webpack_public_path__ + "static/media/iconWrite3.7d34553e.svg";